/* eslint-disable indent */
import generalConfig from '@/config'

const postStatus = generalConfig.postStatus

const postStatusDisplayForInfluencer = {
  [postStatus.AD_STRATEGIST_PENDING]: 'Submitted for Review',
  [postStatus.CLIENT_PENDING]: 'Under Review',
  [postStatus.APPROVE]: 'Your Post is Approved',
  [postStatus.LIVE]: 'Your Post is published',
  [postStatus.COMPLETE]: 'Completed Post'
}

const postStatusDisplayForClient = {
  [postStatus.CLIENT_PENDING]: 'Pending',
  [postStatus.APPROVE]: 'Approved',
  [postStatus.LIVE]: 'Published',
  [postStatus.COMPLETE]: 'Completed'
}

const postStatusDisplayForCS = {
  [postStatus.AD_STRATEGIST_PENDING]: 'Pending Your Approval',
  [postStatus.CLIENT_PENDING]: 'Pending Client Approval',
  [postStatus.APPROVE]: 'Approved By Client',
  [postStatus.LIVE]: 'Post is published',
  [postStatus.COMPLETE]: 'Completed Post'
}

const submissionReviewNotes = {
  beforeStart: `Do note that by approving the draft, it would be deemed that you have considered the style of influencers during the vetting process and agreeable to the Influencer's style of image capture and caption writing.`,
  thankyou: `You will be receiving a copy of the ratings that you have provided in your email inbox.
  Kobe will proceed with sharing the information to the influencers for their next course of actions and keep you updated again`,
  internalApproveWarning: `Do note that you are approving the draft on behalf of the Client. Make sure these drafts are under the correct campaign. Ratings and comments will not be included.`
}

const nonApprovalReasons = [
  `Non-Compliance to brief`,
  `Inaccuracy of factual information`,
  `Clarity of product with image`,
  `Language considerations`,
  `Clarity of Image`,
  `Inaccurate hashtags and mentions`
]

const menuActions = [{
    name: 'View',
    action: 'view',
    icon: 'pageview',
    color: 'default'
  },
  {
    name: 'Edit',
    action: 'edit',
    icon: 'edit'
  },
  {
    name: 'Edit Live Date',
    action: 'editLiveDate',
    icon: 'edit'
  },
  {
    name: 'Assign Campaign',
    action: 'assignCampaign',
    icon: 'library_add'
  },
  {
    name: 'Map Influencer',
    action: 'mapInfluencer',
    icon: 'people_alt'
  },
  {
    name: 'Approve draft',
    action: 'csApprove',
    icon: 'check'
  },
  {
    name: 'Release draft',
    action: 'saleApprove',
    icon: 'check'
  },
  {
    name: 'Direct Release draft',
    action: 'directRelease',
    icon: 'check'
  },
  {
    name: 'Review Post',
    action: 'clientReview',
    icon: 'rate_review'
  },
  {
    name: 'Approve Date',
    action: 'clientApproveDate',
    icon: 'check'
  },
  {
    name: 'Add to Campaign Report',
    action: 'enterPostURL',
    icon: 'publish'
  },
  {
    name: 'Submit Payout',
    action: 'submitPostPayout',
    icon: 'assignment_turned_in'
  },
  {
    name: 'Mark as Metadata Tagged',
    action: 'markAsMetadataTagged',
    icon: 'check'
  },
  {
    name: 'Mark as Complete',
    action: 'markAsComplete',
    icon: 'done_all'
  },
  {
    name: 'Mark as Abuse Resolved',
    action: 'markAsAbuseResolved',
    icon: 'done_all'
  },
  {
    name: 'Release to Client',
    action: 'releaseAbuseResolved',
    icon: 'check'
  },
  {
    name: 'Change Status',
    action: 'changePostStatus',
    icon: 'mdi-pencil-outline'
  }
]

const tableActions = [
  {
    name: 'Assign Campaign',
    action: 'assignCampaign',
    icon: 'library_add'
  },
  {
    name: 'Map Influencer',
    action: 'mapInfluencer',
    icon: 'people_alt'
  },
  {
  name: 'Approve draft',
  action: 'csApprove',
  icon: 'check'
}, {
  name: 'Accept draft',
  action: 'clientApprove',
  icon: 'check'
}, {
  name: 'Direct Release draft',
  action: 'directRelease',
  icon: 'check'
}, {
  name: 'Release draft',
  action: 'saleApprove',
  icon: 'check'
}, {
  name: 'Change Status',
  action: 'changeStatus',
  icon: 'check'
}, {
  name: 'Delete Post',
  action: 'deletePost',
  icon: 'check'
}, {
  name: 'Archive',
  action: 'archivePost',
  icon: 'archive'
}, {
  name: 'Mark as Metadata Tagged',
  action: 'markAsMetadataTagged',
  icon: 'check'
},
{
  name: 'Mark as Abuse Resolved',
  action: 'markAsAbuseResolved',
  icon: 'check'
}, {
  name: 'Release Abuse Resolved',
  action: 'releaseAbuseResolved',
  icon: 'check'
}, {
  name: 'Restore',
  action: 'restore',
  icon: 'restore'
}]

const postConfirmation = {
  approval: {
    [postStatus.AD_STRATEGIST_PENDING]: {
      confirmation: {
        title: 'Are you sure?',
        text: 'Upon confirmation, the post will be sent to client for approval',
        confirmText: 'I agree',
        cancelText: 'Cancel',
        type: 'question'
      },
      confirm: {
        title: 'Success',
        text: 'The post is now pending client approval'
      }
    },
    [postStatus.CLIENT_PENDING]: {
      confirmation: {
        title: 'Are you sure?',
        text: 'Upon confirmation, the post will be confirmed and cannot make changes.',
        confirmText: 'I agree',
        cancelText: 'Cancel',
        type: 'question'
      },
      confirm: {
        title: 'Approved',
        text: 'You have successfully approved this post.'
      }
    },
    [postStatus.APPROVE]: {
      confirmation: {
        title: 'Enter the post URL',
        text: 'Please double check the correct url of this post',
        placeholder: 'Paste the post URL here',
        type: 'url'
      },
      confirm: {
        title: 'Done',
        text: 'The post.'
      }
    },
    [postStatus.LIVE]: {
      confirmation: {
        title: 'Are you sure to mark as complete?',
        text: 'Upon confirmation, the post will be archived to Completed Posts section.',
        confirmText: 'Yes',
        cancelText: 'Cancel',
        type: 'question'
      },
      confirm: {
        title: 'Done',
        text: 'The post is archived'
      }
    }
  }
}

const postFilterStatuses = [
  {
    text: 'All',
    value: '',
    permissions: [
      postStatus.AD_STRATEGIST_PENDING,
      postStatus.CLIENT_PENDING,
      postStatus.APPROVE,
      postStatus.LIVE,
      postStatus.COMPLETE
    ]
  },
  {
    text: 'Campaign not assigned',
    value: 1,
    permissions: [
      postStatus.AD_STRATEGIST_PENDING
    ]
  },
  {
    text: 'Pending to release',
    value: 2,
    permissions: [
      postStatus.AD_STRATEGIST_PENDING
    ]
  },
  {
    text: 'Pending to release',
    value: 13,
    permissions: [
      postStatus.CLIENT_PENDING
    ]
  },
  {
    text: 'Work in progress by CC',
    value: 3,
    permissions: [
      postStatus.AD_STRATEGIST_PENDING
    ]
  },
  {
    text: 'Abuse Reported',
    value: 4,
    permissions: [
      postStatus.CLIENT_PENDING
    ]
  },
  {
    text: 'New',
    value: 5,
    permissions: [
      postStatus.CLIENT_PENDING
    ]
  },
  // {
  //   text: 'Today Submission',
  //   value: 6,
  //   permissions: [
  //     postStatus.APPROVE
  //   ]
  // },
  // {
  //   text: 'Overdue Submission',
  //   value: 7,
  //   permissions: []
  // },
  {
    text: 'Today Live Date',
    value: 9,
    permissions: []
  },
  {
    text: 'Today',
    value: 14,
    permissions: [
      postStatus.APPROVE
    ]
  },
  {
    text: 'This Month',
    value: 15,
    permissions: [
      postStatus.APPROVE
    ]
  },
  {
    text: 'Overdue Live Date',
    value: 10,
    permissions: [
      postStatus.APPROVE
    ]
  },
  {
    text: 'Today Payout Due Date',
    value: 11,
    permissions: []
  },
  {
    text: 'Overdue Payout Due Date',
    value: 12,
    permissions: []
  },
  {
    text: 'Post URL Added',
    value: 8,
    permissions: [
      postStatus.APPROVE,
      postStatus.LIVE,
      postStatus.COMPLETE
    ]
  }
]

const postFilterStatus = {
  CAMPAIGN_NOT_ASSIGNED: 1,
  PENDING_RELEASE: 2,
  WIP_CO: 3,
  ABUSE_REPORTED: 4,
  NEW: 5,
  TODAY: 6,
  OVERDUE: 7,
  POSTURL_ADDED: 8,
  // PRESENT_REPORT: 9,
  TODAY_LIVE: 9,
  OVERDUE_LIVE: 10,
  TODAY_PAYOUTDUE: 11,
  OVERDUE_PAYOUT: 12,
  ABUSE_PENDING_RELEASE: 13
}

const clientPostFilterStatuses = [
  {
    text: 'Pending',
    value: postStatus.CLIENT_PENDING
  },
  {
    text: 'Approved',
    value: postStatus.APPROVE
  },
  {
    text: 'Published',
    value: postStatus.LIVE
  },
  {
    text: 'Completed',
    value: postStatus.COMPLETE
  }
]

const postTypeDeliverables = [
  { type: 'story', shortName: 'IGS', value: 0 },
  { type: 'post', shortName: 'IGP', value: 0 },
  { type: 'carousel', shortName: 'IGC', value: 0 },
  { type: 'video', shortName: 'IGV', value: 0 },
  { type: 'reel', shortName: 'IGR', value: 0 },
  { type: 'tiktok', shortName: 'TTP', value: 0 },
  { type: 'linkedin', shortName: 'LIP', value: 0 },
  { type: 'twitter', shortName: 'XTP', value: 0 }
]

const submissionStates = [
  {
    text: 'All',
    value: ''
  },
  {
    text: 'FULL',
    value: 1
  },
  {
    text: 'PARTIAL',
    value: 2
  },
  {
    text: 'EMPTY',
    value: 3
  }
]

const submissionState = {
  ALL: '',
  FULL: 1,
  PARTIAL: 2,
  EMPTY: 3
}

const postTypes = [
  { type: 'story', typeName: 'IG Story', icon: 'mdi-instagram', iconColor: '#E1306C' },
  { type: 'post', typeName: 'IG Post', icon: 'mdi-instagram', iconColor: '#E1306C' },
  { type: 'carousel', typeName: 'IG Carousel', icon: 'mdi-instagram', iconColor: '#E1306C' },
  // { type: 'video', typeName: 'IG Video' },
  { type: 'reel', typeName: 'IG Reel', icon: 'mdi-instagram', iconColor: '#E1306C' },
  { type: 'tiktok', typeName: 'TikTok', imgIcon: '/static/img/tiktok-32.png' },
  { type: 'youtube', typeName: 'YouTube', icon: 'mdi-youtube', iconColor: '#FF0000' },
  { type: 'facebook', typeName: 'Facebook', icon: 'mdi-facebook', iconColor: '#1877F2' },
  { type: 'linkedin', typeName: 'LinkedIn Post', icon: 'mdi-linkedin', iconColor: '#0A66C2' },
  { type: 'twitter', typeName: 'X (Twitter) Post', imgIcon: '/static/img/x-logo.svg' },
  { type: 'others', typeName: 'Others', icon: 'mdi-help-circle', iconColor: '#616161' }
]

export default Object.assign({}, {
  postStatusDisplayForInfluencer,
  postStatusDisplayForClient,
  postStatusDisplayForCS,
  submissionReviewNotes,
  nonApprovalReasons,
  menuActions,
  tableActions,
  postConfirmation,
  postFilterStatuses,
  postFilterStatus,
  clientPostFilterStatuses,
  submissionStates,
  submissionState,
  postTypeDeliverables,
  postTypes
})



// WEBPACK FOOTER //
// ./src/components/views/Post/postConfig.js